module.exports = __webpack_public_path__ + "static/media/38-7.f4968831.mp3";